import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { OptimizelyExperiments } from 'constants/optimizely'
import { getFlashFreeChildCount, getTotalChildren, getTotalInfants } from 'components/SearchKit/SearchTiles/accommodations/hotelSearchTileLabelsUtils'
import useExperiment from 'hooks/Optimizely/useExperiment'

interface UseChildrenStayFreeParams {
  offerType: App.OfferType
  filters?: App.OfferListFilters
  capacitiesByRate: Array<Array<App.RoomCapacity>>
}

function useChildrenStayFree({ offerType, filters, capacitiesByRate }: UseChildrenStayFreeParams) {
  const intl = useIntl()

  const hasChildrenOrInfants = useMemo(
    () => getTotalChildren(filters) + getTotalInfants(filters) > 0,
    [filters],
  )

  const { isAnyVariant } = useExperiment(
    OptimizelyExperiments.croChildrenStayFreeTag,
    {
      canActivate: hasChildrenOrInfants,
    },
  )

  const freeStayLabel = useMemo(() => {
    const count = getFlashFreeChildCount({ offerType, filters, capacitiesByRate })
    if (count === 0) return undefined
    return intl.formatMessage(
      {
        id: 'NBC+WbfUtm',
        defaultMessage: '{count, plural, one {Free stay for your child} other {Free stay for all of your children}}',
        description: 'Label on search tiles indicating children/infants stay free with the hotel package',
      },
      { count },
    )
  }, [intl, offerType, filters, capacitiesByRate])

  return { isChildrenStayFreeEnabled: isAnyVariant, freeStayLabel }
}

export default useChildrenStayFree
